import { render } from "./_primaryEmail.vue?vue&type=template&id=01ae6fc1&scoped=true"
import script from "./_primaryEmail.vue?vue&type=script&lang=js"
export * from "./_primaryEmail.vue?vue&type=script&lang=js"

import "./_primaryEmail.vue?vue&type=style&index=0&id=01ae6fc1&lang=css"
import "./_primaryEmail.vue?vue&type=style&index=1&id=01ae6fc1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ae6fc1"]])

export default __exports__